export const PROCESSING_DATE_AND_TIME = "Processing date and time"